import { motion } from "framer-motion";

export function KineticLine({ children, className = "", delay = 0, inView = false }) {
  const inner = (
    <motion.span
      className={`block will-change-transform ${className}`}
      initial={{ y: "115%", rotate: 2 }}
      {...(inView
        ? { whileInView: { y: "0%", rotate: 0 }, viewport: { once: true, margin: "-80px" } }
        : { animate: { y: "0%", rotate: 0 } })}
      transition={{ duration: 1.1, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.span>
  );
  return <span className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">{inner}</span>;
}

export function Reveal({ children, className = "", delay = 0, y = 40 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}
